// ══════════════════════════════════════════════════════════════
// COMPASS – Fund Actions
// ══════════════════════════════════════════════════════════════
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { FundDto } from '../../api/models/fund-dto';

export const FundActions = createActionGroup({
  source: 'Fund',
  events: {
    // Load all funds for a management company
    'Load Funds': props<{ managementCompanyId: string }>(),
    'Load Funds Success': props<{ funds: FundDto[] }>(),
    'Load Funds Failure': props<{ error: string }>(),

    // Load single fund by id
    'Load Fund': props<{ fundId: string }>(),
    'Load Fund Success': props<{ fund: FundDto }>(),
    'Load Fund Failure': props<{ error: string }>(),

    // Create fund
    'Create Fund': props<{ fund: FundDto; managementCompanyId: string }>(),
    'Create Fund Success': props<{ fund: FundDto; managementCompanyId: string }>(),
    'Create Fund Failure': props<{ error: string }>(),

    // Update fund
    'Update Fund': props<{ fund: FundDto }>(),
    'Update Fund Success': props<{ fund: FundDto }>(),
    'Update Fund Failure': props<{ error: string }>(),

    // Delete fund
    'Delete Fund': props<{ fundId: string; managementCompanyId: string }>(),
    'Delete Fund Success': props<{ fundId: string }>(),
    'Delete Fund Failure': props<{ error: string }>(),

    // Clear
    'Clear Funds': emptyProps(),
  },
});
